<template>
    <TagComponent :variant="variantMap[orgAdmin]" :value="valueMap[orgAdmin]" />
</template>

<script setup lang="ts">
import type { TagVariant } from '@/components/tables/types';
import TagComponent from './TagComponent.vue';

defineProps<{
    orgAdmin: 0 | 1;
}>();

const valueMap: Record<0 | 1, string> = {
    0: 'org-user',
    1: 'org-admin',
};

// Status-based variants
const variantMap: Record<number, TagVariant> = {
    0: 'success',
    1: 'hold',
};
</script>
